import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, PaymentMethodEnum } from '@systemeio/ui';
import DigitalProductEdit from 'modules/digital-product/components/digital-product-edit';
import DigitalProductSelect from 'modules/digital-product/components/digital-product-select';
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum';
import { DigitalProductTabEnum } from 'modules/digital-product/enums/digital-product-tab-enum';
import { useDigitalProductsList } from 'modules/digital-product/hooks/use-digital-product-list';
import { DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface';
import { DigitalOfferEditInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/digital-offer-interface';
import React, { FC, useState } from 'react';
import { Loader } from 'shared/components/loader';
import { DigitalProductDeleteModal, useDigitalProductDeleteModal } from './components/digital-product-delete';
export interface DigitalProductProps {
  product: DigitalProductInterface | null;
  onSave: (data: DigitalOfferEditInterface['digitalProduct']) => Promise<void>;
  currency: CurrencyEnum;
  paymentMethods: PaymentMethodEnum[];
  isBump?: boolean;
  source: DigitalProductSourceEnum;
}
const DigitalProduct: FC<DigitalProductProps> = t0 => {
  const $ = _c(45);
  const {
    product,
    paymentMethods,
    onSave,
    currency,
    isBump,
    source
  } = t0;
  const [tab, setTab] = useState(DigitalProductTabEnum.select);
  const deleteModal = useDigitalProductDeleteModal();
  const {
    digitalProductList,
    mutate
  } = useDigitalProductsList(currency, source);
  if (!digitalProductList) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== digitalProductList || $[2] !== product?.id) {
    t1 = digitalProductList.find(el => el.id === product?.id) ?? null;
    $[1] = digitalProductList;
    $[2] = product?.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const digitalProduct = t1;
  let t2;
  if ($[4] !== deleteModal.open || $[5] !== digitalProduct?.id || $[6] !== digitalProductList || $[7] !== isBump || $[8] !== onSave || $[9] !== tab) {
    t2 = tab === DigitalProductTabEnum.select && <DigitalProductSelect digitalProductId={digitalProduct?.id} onSave={onSave} isBump={isBump} setTab={setTab} digitalProductList={digitalProductList} onDelete={deleteModal.open} />;
    $[4] = deleteModal.open;
    $[5] = digitalProduct?.id;
    $[6] = digitalProductList;
    $[7] = isBump;
    $[8] = onSave;
    $[9] = tab;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== currency || $[12] !== isBump || $[13] !== onSave || $[14] !== paymentMethods || $[15] !== source || $[16] !== tab) {
    t3 = tab === DigitalProductTabEnum.create && <DigitalProductEdit onSave={onSave} paymentMethods={paymentMethods} currency={currency} setTab={setTab} isBump={isBump} source={source} />;
    $[11] = currency;
    $[12] = isBump;
    $[13] = onSave;
    $[14] = paymentMethods;
    $[15] = source;
    $[16] = tab;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== currency || $[19] !== digitalProduct || $[20] !== isBump || $[21] !== paymentMethods || $[22] !== source || $[23] !== tab) {
    t4 = tab === DigitalProductTabEnum.edit && digitalProduct && <DigitalProductEdit digitalProduct={digitalProduct} paymentMethods={paymentMethods} currency={currency} setTab={setTab} isBump={isBump} source={source} />;
    $[18] = currency;
    $[19] = digitalProduct;
    $[20] = isBump;
    $[21] = paymentMethods;
    $[22] = source;
    $[23] = tab;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== deleteModal.digitalProductId || $[26] !== digitalProductList) {
    t5 = digitalProductList.find(el_0 => el_0.id === deleteModal.digitalProductId)?.name;
    $[25] = deleteModal.digitalProductId;
    $[26] = digitalProductList;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== deleteModal || $[29] !== digitalProduct?.id || $[30] !== mutate || $[31] !== onSave) {
    t6 = async () => {
      await deleteModal.deleteDigitalProduct();
      await mutate(data => data?.filter(e => e.id !== deleteModal.digitalProductId), false);
      if (digitalProduct?.id === deleteModal.digitalProductId) {
        onSave(null);
      }
    };
    $[28] = deleteModal;
    $[29] = digitalProduct?.id;
    $[30] = mutate;
    $[31] = onSave;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== deleteModal.afterLeave || $[34] !== deleteModal.close || $[35] !== deleteModal.digitalProductLinkedOffersCount || $[36] !== deleteModal.opened || $[37] !== t5 || $[38] !== t6) {
    t7 = <DigitalProductDeleteModal opened={deleteModal.opened} digitalProductName={t5} digitalProductLinkedOffersCount={deleteModal.digitalProductLinkedOffersCount} onClose={deleteModal.close} afterLeave={deleteModal.afterLeave} onConfirm={t6} />;
    $[33] = deleteModal.afterLeave;
    $[34] = deleteModal.close;
    $[35] = deleteModal.digitalProductLinkedOffersCount;
    $[36] = deleteModal.opened;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  let t8;
  if ($[40] !== t2 || $[41] !== t3 || $[42] !== t4 || $[43] !== t7) {
    t8 = <div className="flex flex-col gap-5">{t2}{t3}{t4}{t7}</div>;
    $[40] = t2;
    $[41] = t3;
    $[42] = t4;
    $[43] = t7;
    $[44] = t8;
  } else {
    t8 = $[44];
  }
  return t8;
};
export default DigitalProduct;